export default __webpack_public_path__ + "static/media/vip-up-level-ico.abb01157.svg";